<template>
  <!-- 通过key实现tab切换实现组件更新，否则就要实现各种tab下的数据切换 -->
  <item
    :key="type"
    :type="type"
    @tab="onTab"
  ></item>
</template>

<script>
/** 离线设备列表 */
import item from './children/offline_device_item.vue';

export default {
  name: 'offlineDevice',
  mixins: [],
  components: {
    item
  },
  props: {
  },
  data() {
    /*
    组织设备（组织下的所有设备，默认)
    我的设备（注：分配给我的设备），
    */
    return {
      // 1 - 组织设备  2 - 我的设备
      type: 1,
    };
  },
  computed: {
  },
  watch: {
  },
  filters: {
  },
  directives: {
  },
  methods: {
    onTab(value) {
      this.type = value;
    },
  },
  created() {
  },
  mounted() {
  },
};
</script>

<style>
</style>
